exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card[data-v-29e0f4d8]:hover{background:#f5f8fa;border-radius:8px}.card[data-v-29e0f4d8]{padding:10px;cursor:pointer}a[data-v-29e0f4d8]{color:#777}.icon[data-v-29e0f4d8]{color:#189ce2;border-color:#168ccb;font-size:1.8rem}", "", {"version":3,"sources":["/./src/components/app/general_notification_components/CertificateReadyNotification.vue"],"names":[],"mappings":"AACA,6BACA,mBAAoB,AACpB,iBAAmB,CAClB,AACD,uBACA,aAAc,AACd,cAAgB,CACf,AACD,mBACA,UAAe,CACd,AACD,uBACA,cAAe,AACf,qBAAsB,AACtB,gBAAkB,CACjB","file":"CertificateReadyNotification.vue","sourcesContent":["\n.card[data-v-29e0f4d8]:hover {\nbackground: #f5f8fa;\nborder-radius: 8px;\n}\n.card[data-v-29e0f4d8] {\npadding: 10px;\ncursor: pointer;\n}\na[data-v-29e0f4d8] {\ncolor: #777777;\n}\n.icon[data-v-29e0f4d8] {\ncolor: #189ce2;\nborder-color: #168ccb;\nfont-size: 1.8rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-29e0f4d8&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app/general_notification_components/CertificateReadyNotification.vue
// module id = 606
// module chunks = 2